import React from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import SearchSelectBox from "../../../components/SearchSelectBox";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import useCustomValidation from "../validationSchema";
import { getStatusLeadContacts } from "../../../api/statusLeadContact";
import { addLeadContact } from "../../../api/leadContacts";
import { getLeads } from "../../../api/lead";
const AddLeadContact = () => {
    const { t } = useTranslation();
    const { addLeadContactSchema } = useCustomValidation();
    const navigate = useNavigate();
    const leadContactId = localStorage.getItem("leadContactId");
    const { setData, loading, error, success } = useResponse(addLeadContact, () => {
        navigate(`/leads/show/${leadContactId}`);
    });

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            type: "",
            notes: "",
            potentialBudget: "",
            statusLeadContactId: null,
            leadId: null
        },
        validationSchema: addLeadContactSchema,
        onSubmit: (values) => {
            const data = {
                type: values.type,
                notes: values.notes,
                potentialBudget: values.potentialBudget,
                statusLeadContactId: values.statusLeadContactId?.value,
                leadId: values.leadId?.value,
            };
            setData({ data, type: "add" });
        },
    });

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title={`${t("Add")} ${t("Lead Contact")}`} />

                <Form
                    className="needs-validation"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                    }}
                >
                    <Row>
                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Type")}</Label>
                                <Input
                                    name="type"
                                    placeholder={t("Type")}
                                    type="text"
                                    onChange={validation.handleChange}
                                    value={validation.values.type}
                                    invalid={!!(validation.touched.type && validation.errors.type)}
                                />
                                <FormFeedback>{validation.errors.type}</FormFeedback>
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Potential Budget")}</Label>
                                <Input
                                    name="potentialBudget"
                                    placeholder={t("Potential Budget")}
                                    type="number"
                                    onChange={validation.handleChange}
                                    value={validation.values.potentialBudget}
                                    invalid={
                                        !!(
                                            validation.touched.potentialBudget &&
                                            validation.errors.potentialBudget
                                        )
                                    }
                                />
                                <FormFeedback>{validation.errors.potentialBudget}</FormFeedback>
                            </FormGroup>
                        </Col>

                        <Col md="12">
                            <FormGroup className="mb-3">
                                <Label>{t("Notes")}</Label>
                                <Input
                                    name="notes"
                                    placeholder={t("Notes")}
                                    type="textarea"
                                    rows="4"
                                    onChange={validation.handleChange}
                                    value={validation.values.notes}
                                    invalid={!!(validation.touched.notes && validation.errors.notes)}
                                />
                                <FormFeedback>{validation.errors.notes}</FormFeedback>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Lead")}</Label>
                                <SearchSelectBox
                                    api={getLeads}
                                    name="leadId"
                                    placeholder={t("Select Lead")}
                                    value={validation.values.leadId}
                                    label="name"
                                    setValue={(value) => validation.setFieldValue("leadId", value)}
                                    error={!!(validation.touched.leadId && validation.errors.leadId)}
                                />
                                {validation.touched.leadId && validation.errors.leadId && (
                                    <div className="text-danger mt-1">{validation.errors.leadId}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Status")}</Label>
                                <SearchSelectBox
                                    api={getStatusLeadContacts}
                                    name="statusLeadContactId"
                                    placeholder={t("Select Status")}
                                    value={validation.values.statusLeadContactId}
                                    label="name"
                                    setValue={(value) =>
                                        validation.setFieldValue("statusLeadContactId", value)
                                    }
                                    error={
                                        !!(
                                            validation.touched.statusLeadContactId &&
                                            validation.errors.statusLeadContactId
                                        )
                                    }
                                />
                                {validation.touched.statusLeadContactId &&
                                    validation.errors.statusLeadContactId && (
                                        <div className="text-danger mt-1">
                                            {validation.errors.statusLeadContactId}
                                        </div>
                                    )}
                                {/* Link to Add New Lead Source */}
                                <Link to="/statusleadcontacts/add" className="text-primary mt-2 d-block">
                                    {t("Add New Lead Source")}
                                </Link>
                            </FormGroup>
                        </Col>

                        <Col xs="12">
                            <FormButtonHandler loading={loading} />
                            <ResultHandler error={error} success={success} />
                        </Col>
                    </Row>
                </Form>
            </Container>
        </div>
    );
};

export default AddLeadContact;
